export default {
	data() {
		return {
			commonPageSize: 15, // 配置公共页码
			searchData: { // 配置公共搜索项及limit字段
				limit: 15
			}
		}
	},
	async created() {
		// 同步方式获取接口中的页码数
		let pageLimit = await this.$util.getPageLimit();
		if (pageLimit <= 0) pageLimit = 15;
		this.commonPageSize = pageLimit
		this.searchData.limit = pageLimit
	},
}